// Generated file - do not change manually!

/**
 * Different types of <code>Breadcrumbs</code>.
 */
export enum BreadcrumbsDesign {
  /**
   * All items are displayed as links.
   */
  NoCurrentPage = 'NoCurrentPage',

  /**
   * Shows the current page as the last item in the trail. The last item contains only plain text and is not a link.
   */
  Standard = 'Standard'
}
